export var defaultProps = {
    className: '',
    style: undefined,
    data: [],
    targetKeys: [],
    selectedKeys: [],
    titles: ['', ''],
    onChange: function (newTargetKeys, direction, moveKeys) { },
    onBeforeChange: function (newTargetKeys, direction, moveKeys) { return true; },
    onSelectChange: function (sourceSelectedKeys, targetSelectedKeys) { },
};
